import { CONTENT_PLATFORM_PROPERTY_NAME, ContentObjectTypes, getContentPropertyValue, useContentObjectType } from 'content-management-data-lib';
import { useContentDetailsDataProvider } from 'content-management-details-lib/providers/ContentDetailsDataProvider';
import { DowngradeLimitAlert } from 'content-management-restrictions-lib';
import ScopeDowngradeAlert from 'page-lib/components/ScopeDowngradeAlert';
import { PAGE_PROPERTY_NAMES } from 'page-lib/constants/propertyNames';
import { DYNAMIC_PAGE_ACCESS, LANDING_PAGES_PASSWORD_PROTECTION, MARKETING_CONTENT_RESTRICTED_WRITE, SITE_PAGES_PASSWORD_PROTECTION } from 'page-lib/constants/scopes';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { useAppSelector } from '../reducers';
import { getUserScopes } from '../selectors';
import { getContentDynamicPageHubDbTableId } from '../utils/dynamicPageUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DowngradeAlerts = () => {
  const {
    contentObject
  } = useContentDetailsDataProvider();
  const {
    contentObjectType
  } = useContentObjectType();
  const userScopes = useAppSelector(getUserScopes);
  const privatePagesScopeName = contentObjectType === ContentObjectTypes.LANDING_PAGE ? LANDING_PAGES_PASSWORD_PROTECTION : SITE_PAGES_PASSWORD_PROTECTION;
  const publicAccessRuleType = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS_RULE_TYPE);
  const hubDbTableId = getContentDynamicPageHubDbTableId(contentObject);
  const dynamicPageDataSourceType = getContentPropertyValue(contentObject, PAGE_PROPERTY_NAMES.DYNAMIC_PAGE_DATA_SOURCE_TYPE);
  const dynamicPageSourceId = getContentPropertyValue(contentObject, PAGE_PROPERTY_NAMES.DYNAMIC_PAGE_DATA_SOURCE_ID);
  const isPageUsingDynamicScopes = !!hubDbTableId || !!(dynamicPageDataSourceType && dynamicPageSourceId);
  const sharedProps = {
    alertSpaceStyleProps: {
      marginBlock: '200'
    },
    userScopes,
    viewMode: 'DETAIL'
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DowngradeLimitAlert, {
      alertProps: {
        marginBlock: '200'
      }
    }), /*#__PURE__*/_jsx(ScopeDowngradeAlert, Object.assign({}, sharedProps, {
      scopeName: DYNAMIC_PAGE_ACCESS,
      alertType: "dynamicPagesToBeUnpublished",
      isPageUsingScope: isPageUsingDynamicScopes
    })), /*#__PURE__*/_jsx(ScopeDowngradeAlert, Object.assign({}, sharedProps, {
      scopeName: privatePagesScopeName,
      alertType: "privatePagesToBeUnpublished",
      isPageUsingScope: !!getContentPropertyValue(contentObject, PAGE_PROPERTY_NAMES.PASSWORD)
    })), /*#__PURE__*/_jsx(ScopeDowngradeAlert, Object.assign({}, sharedProps, {
      scopeName: MARKETING_CONTENT_RESTRICTED_WRITE,
      alertType: "audienceAccessPagesToBeUnpublished",
      isPageUsingScope: publicAccessRuleType !== PublicAccessRuleTypes.PUBLIC
    }))]
  });
};
export default DowngradeAlerts;